import axios from 'axios'

const baseURL = process.env.REACT_APP_BACKEND_URL;

axios.defaults.baseURL = baseURL

const token = sessionStorage.getItem('token') || localStorage.getItem('token')

axios.defaults.headers = {
    Authorization: `Bearer ${token}`
}

const abortController = axios.CancelToken.source()

export { axios, abortController }